import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Avatar } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Navbar: React.FC = () => {
  return (
    <AppBar position="sticky">
      <Toolbar>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit',
          }}
          component={RouterLink}
          to="/"
        >
          <Avatar
            src="/cloud-dev-icon.svg"
            alt="Cloud Dev"
            sx={{
              width: 40,
              height: 40,
              mr: 2,
              bgcolor: 'transparent',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
            }}
          >
            Mohsin Ahmed
          </Typography>
        </Box>
        <Box>
          <Button
            color="inherit"
            component={RouterLink}
            to="/"
            sx={{ mx: 1 }}
          >
            Home
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/about"
            sx={{ mx: 1 }}
          >
            About
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/projects"
            sx={{ mx: 1 }}
          >
            Projects
          </Button>
          <Button
            color="inherit"
            component={RouterLink}
            to="/contact"
            sx={{ mx: 1 }}
          >
            Contact
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 